import React from 'react';
import Reflux from 'reflux';
import moment from 'moment-timezone';
import { ApiMixin } from 'mixins';
import LeadActions from 'actions/leadActions';
import LeadStore from 'stores/leadStore';
import LoadingIndicator from 'components/loadingIndicator';
import RouteError from 'components/errors/routeError';
import NotFoundError from 'components/errors/notFoundError';

const ERROR_TYPES = {
    LEAD_NOT_FOUND: 'LEAD_NOT_FOUND',
    OTHER: 'OTHER',
};

export default React.createClass({
    propTypes: {
        children: React.PropTypes.node.isRequired,
        params: React.PropTypes.object.isRequired,
    },

    mixins: [
        ApiMixin,
        Reflux.connect(LeadStore, 'lead'),
    ],

    getInitialState() {
        return {
            loading: true,
            error: null,
            lead: {},
        };
    },

    componentDidMount() {
        this.loadLead();
    },

    loadLead() {
        this.api.request(`/api/leads/${this.props.params.leadId}`, {
            method: 'GET',
            success: (data) => {
                const newLead = data;
                newLead.event.date = moment(data.event.date);

                this.setState({ loading: false, error: null, lead: newLead }, () => {
                    LeadActions.loadLead(data);
                });
            },
            error: (xhr) => {
                if (xhr.status === 404) {
                    this.setState({ loading: false, error: ERROR_TYPES.LEAD_NOT_FOUND });
                } else {
                    this.setState({ loading: false, error: ERROR_TYPES.OTHER });
                }
            },
        });
    },

    render() {
        if (this.state.error) {
            if (this.state.error === ERROR_TYPES.LEAD_NOT_FOUND) {
                return <NotFoundError />;
            }

            return <RouteError />;
        }

        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        const childrenWithProps = React.Children.map(this.props.children, child => React.cloneElement(child, {
            lead: this.state.lead,
        }));

        return (
            <div className="page-container">
                <div className="page-header">
                    <h2>{this.state.lead.event.title}</h2>
                </div>

                {childrenWithProps}
            </div>
        );
    },
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/lead.jsx